const buttonClass = "bns1dlc";
export default buttonClass;

require("./Button.styles.linaria.module.css!=!../../../../../@linaria+webpack5-loader@4.1.17_webpack@5.83.1/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./Button.styles.js");